module.exports = __webpack_public_path__ + "mainassets/img/faq-3.7606b2f5.svg";